import { Box } from "@material-ui/core";
import { LegendBoxList, LegendCssIcoListItem, LegendBoxContentsName, LegendBoxListItemText } from "../../legend/LegendBoxComponents";
import { memo } from "react";
import { useTranslation } from "react-i18next";

function LegendGassScale() {
  const {t} = useTranslation();
  return (
    <Box sx={{minWidth: 150}}>
      <Box>
        <LegendBoxContentsName>VIS</LegendBoxContentsName>
        <LegendBoxList>
          <LegendCssIcoListItem background={"rgb(255, 0, 0)"} text={t('LEGEND_GASS_VIS_SEVERE', {value: '5000'})}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(255, 255, 0)"} text={t('LEGEND_GASS_VIS_WARNING', {value: '5000-9900'})}></LegendCssIcoListItem>
          {/* <LegendCssIcoListItem background={"rgb(86, 254, 177)"} text={t('LEGEND_GASS_VIS_FINE', {value: '9900'})}></LegendCssIcoListItem> */}
        </LegendBoxList>
      </Box>
      <Box style={{marginTop: 10}}>
        <LegendBoxContentsName>CIG</LegendBoxContentsName>
        <LegendBoxList>
          <LegendCssIcoListItem background={"rgb(255, 0, 0)"} text={t('LEGEND_GASS_CIG_SEVERE', {value: '1000'})}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(255, 255, 0)"} text={t('LEGEND_GASS_CIG_WARNING', {value: '1000-2000'})}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(86, 254, 177)"} text={t('LEGEND_GASS_CIG_FINE', {value: '2000-20000'})}></LegendCssIcoListItem>
          <LegendBoxListItemText style={{paddingLeft: 0}}>{t('LEGEND_GASS_CIG_COLORLESS', {value: '20000'})}</LegendBoxListItemText>
        </LegendBoxList>
      </Box>
    </Box>
  )
}

export default memo(LegendGassScale);